import { useEffect, useRef, useState } from 'react'
import cn from 'classnames'

import { NetworkLabel } from 'components/ui/network-label'
import { CoinList } from 'components/ui/calculator/components/coins-dropdown'

import { formatCurrency } from 'utils/formatters'
import IconBigInputArrow from 'images/icon-input-big-arrow.svg'

import { useAppSelector } from 'store/hooks'
import { getCurrencies } from 'store/reducers/currencies'

import styles from '../../../../styles.module.scss'
import useWindowWidth from '../../../../../../../../../hooks/use-window-width'
import useOnClickOutside from '../../../../../../../../../hooks/use-on-click-outside'

export const SelectCurrency = ({
  coin,
  setCoin,
  isVip = false,
  className = '',
  logoClassname = '',
  selectedClassaname = '',
  labelClassname = '',
  tickerClassname = '',
}) => {
  const list = useAppSelector(getCurrencies)
  const [isVisibleList, setVisibleList] = useState(false)
  const width = useWindowWidth()
  const isMobile = width < 764
  const ref = useRef(null)

  const [currencyList, setCurrencyList] = useState([])

  const handleCoinListClose = () => {
    setVisibleList(false)
  }

  const handleChooseCoin = (coin) => {
    setCoin(coin)
    handleCoinListClose()
  }

  useEffect(() => {
    if (isVip) {
      const filtered = list
        .filter((i) => i.is_loan_deposit_enabled)
        .sort((a, b) => a.loan_deposit_priority - b.loan_deposit_priority)
      setCurrencyList(filtered)
    } else {
      const filtered = list
        .filter((i) => i.is_allowed_for_wallet)
        .sort((a, b) => {
          if (a.exchange_priority === null) return 1
          if (b.exchange_priority === null) return -1
          
          return a.exchange_priority - b.exchange_priority
        })
      setCurrencyList(filtered)
    }
  }, [list])

  useOnClickOutside(ref, () => setVisibleList(false))

  return (
    <>
      {!isVip && <div className={cn(styles.addAddressPopupInputTitle, labelClassname)}>Token</div>}
      <div ref={ref} className={cn(styles.addAddressPopup_coin_wrapper, {
        [styles.vip]: isVip,
        [styles['coin__wrapper-active']]: isVisibleList
      }, className)}>
        <div
          onClick={() => setVisibleList((st) => !st)}
          className={cn(styles.addAddressPopup_coinInfo, { [styles.vip]: isVip }, selectedClassaname)}
        >
          {coin && (
            <>
              <img
                className={cn(styles.addAddressPopup_coinInfo_Logo, logoClassname)}
                alt={coin.code}
                src={coin.logo_url}
                width={isMobile ? 16 : 48}
                height={isMobile ? 16 : 48}
              />
              <div className={cn(styles.addAddressPopup_coinInfo_ticker, tickerClassname)}>{formatCurrency(coin, true)}</div>
              <NetworkLabel className={styles.addAddressPopup_coinInfo_network} currency={coin} />
              {isMobile && coin.name && <div className={styles.addAddressPopup_coinInfo_name}>{coin.name}</div>}
            </>
          )}
        </div>
        <div className={cn(styles.coin__arrow, { [styles['coin__arrow-active']]: isVisibleList })}>
          {list.length > 0 && (
            <img
              src={IconBigInputArrow}
              alt="IconInputArrow"
              width={20}
              height={10}
              onClick={() => setVisibleList((st) => !st)}
            />
          )}
        </div>

        {isVisibleList && (
          <CoinList
            list={currencyList}
            selected={coin}
            onChoose={handleChooseCoin}
            isStableFirst={isVip}
            isVip={isVip}
            listFullWidth
            isVisibleList={isVisibleList}
            onClose={() => setVisibleList(false)}
          />
        )}
      </div>
    </>
  )
}
